import { Chip } from "@heroui/react";

import { formatFrontDate } from "@onesolution/utils";

export default function Deadline({ date }: { date: string }) {
	const convertedDate = formatFrontDate(date);

	if (!convertedDate) return null;

	return (
		<div className="min-w-[100px]">
			<Chip
				color="default"
				variant="flat"
				size="sm"
				radius="sm"
				className="text-xs"
			>
				{convertedDate}
			</Chip>
		</div>
	);
}
